import {Box} from "@mui/material";
import {Navigate, Route, Routes} from "react-router-dom";

import {lazy, useContext, Suspense} from "react";
import AuthContext from "./View/Context/AuthContext";
// import PageHome from "./View/Pages/PageHome";
// import SlidesendingIndex from "./View/Slidesending/SlidesendingIndex";
// import SlidesendingView from "./View/Slidesending/SlidesendingView";
// import MessageIndex from "./View/Message/MessageIndex";
// import MenuitemIndex from "./View/Menuitem/MenuitemIndex";
const SlidesendingIndex = lazy(() => import("./View/Slidesending/SlidesendingIndex"))
const SlidesendingView = lazy(() => import("./View/Slidesending/SlidesendingView"))
const MessageIndex = lazy(() => import("./View/Message/MessageIndex"))
const MenuitemIndex = lazy(() => import("./View/Menuitem/MenuitemIndex"))

// import FindingOverview from "./View/Finding/FindingOverview";
// import FindingIndex from "./View/Finding/FindingIndex";
// import FindingView from "./View/Finding/FindingView";
const FindingView = lazy(() => import("./View/Finding/FindingView"))
const FindingIndex = lazy(() => import("./View/Finding/FindingIndex"))
const FindingOverview = lazy(() => import("./View/Finding/FindingOverview"))

// import StockIndex from "./View/Stock/StockIndex";
// import StockMirror from "./View/Stock/StockMirror";
// import StockStart from "./View/Stock/StockStart";
// import StockEnd from "./View/Stock/StockEnd";
// import StockView from "./View/Stock/StockView";
const StockView = lazy(() => import("./View/Stock/StockView"))
const StockEnd = lazy(() => import("./View/Stock/StockEnd"))
const StockStart = lazy(() => import("./View/Stock/StockStart"))
const StockMirror = lazy(() => import("./View/Stock/StockMirror"))
const StockIndex = lazy(() => import("./View/Stock/StockIndex"))


// import UserIndex from "./View/Users/UserIndex";
// import UserView from "./View/Users/UserView";
// import AuditIndex from "./View/Audit/AuditIndex";
// import AuditView from "./View/Audit/AuditView";
// import PageUnknown from "./View/Pages/PageUnknown";
// import AuditMirror from "./View/Audit/AuditMirror";
// import ManufacturerIndex from "./View/Manufacturer/ManufacturerIndex";
// import ManufacturerMirror from "./View/Manufacturer/ManufacturerMirror";
// import ManufacturerView from "./View/Manufacturer/ManufacturerView";
// import AbsentView from "./View/Absent/AbsentView";
// import AbsentAdd from "./View/Absent/AbsentAdd";
// import UserAdd from "./View/Users/UserAdd";
// import UserMe from "./View/Users/UserMe";
// import MeetingtypeIndex from "./View/Meetingtype/MeetingtypeIndex";
// import MeetingtypeView from "./View/Meetingtype/MeetingtypeView";
// import FindingtypeIndex from "./View/Findingtype/FindingtypeIndex";
// import FindingtypeView from "./View/Findingtype/FindingtypeView";
// import MaintenancetypeIndex from "./View/Maintenancetype/MaintenancetypeIndex";
// import MaintenancetypeEdit from "./View/Maintenancetype/MaintenancetypeEdit";
// import MeetingIndex from "./View/Meeting/MeetingIndex";
// import MeetingView from "./View/Meeting/MeetingView";
// import DeviceIndex from "./View/Device/DeviceIndex";
// import DeviceView from "./View/Device/DeviceView";
// import ActivityIndex from "./View/Activity/ActivityIndex";
// import ActivityView from "./View/Activity/ActivityView";
// import AppointmentIndex from "./View/Appointment/AppointmentIndex";
// import AppointmentView from "./View/Appointment/AppointmentView";
// import ManagementreviewIndex from "./View/Managementreview/ManagementreviewIndex";
// import ManagementreviewView from "./View/Managementreview/ManagementreviewView";
// import QualitydashboardView from "./View/Managementreview/QualitydashboardView";
// import ActionnameIndex from "./View/Actionname/ActionnameIndex";
// import ActionnameView from "./View/Actionname/ActionnameView";
// import BarcodeScan from "./View/Barcode/BarcodeScan";
// import DayNew from "./View/Day/DayNew";
// import UserChangePassword from "./View/Users/UserChangePassword";
// import AppointmentAdd from "./View/Appointment/AppointmentAdd";
// import OrderIndex from "./View/Orders/OrderIndex";
// import OrderView from "./View/Orders/OrderView";
// import DeviceMaintenance from "./View/Device/DeviceMaintenance";
// import MaintenancedoneView from "./View/Maintenancedone/MaintenancedoneView";
// import DayRemarks from "./View/Day/DayRemarks";
// import QuarpaView from "./View/Quarpa/QuarpaView";
// import NotificationView from "./View/Notification/NotificationView";
// import AuditPdf from "./View/Audit/AuditPdf";
// import QuarpaIndex from "./View/Quarpa/QuarpaIndex";
// import QuarpaPublicIndex from "./View/Quarpa/QuarpaPublicIndex";
// import ProfileIndex from "./View/Profiles/ProfileIndex";
// import ProfileView from "./View/Profiles/ProfileView";
// import RiskgroupIndex from "./View/Riskgroup/RiskgroupIndex";
// import RiskgroupView from "./View/Riskgroup/RiskgroupView";
// import RiskView from "./View/Risk/RiskView";


const PageUnknown = lazy(() => import("./View/Pages/PageUnknown"))

const AuditIndex = lazy(() => import("./View/Audit/AuditIndex"))
const AuditView = lazy(() => import("./View/Audit/AuditView"))
const AuditMirror = lazy(() => import("./View/Audit/AuditMirror"))

const ManufacturerIndex = lazy(() => import("./View/Manufacturer/ManufacturerIndex"))
const ManufacturerMirror = lazy(() => import("./View/Manufacturer/ManufacturerMirror"))
const ManufacturerView = lazy(() => import("./View/Manufacturer/ManufacturerView"))

const AbsentView = lazy(() => import("./View/Absent/AbsentView"))
const AbsentAdd = lazy(() => import("./View/Absent/AbsentAdd"))

const UserAdd = lazy(() => import("./View/Users/UserAdd"))
const UserMe = lazy(() => import("./View/Users/UserMe"))
const UserIndex = lazy(() => import("./View/Users/UserIndex"))
const UserView = lazy(() => import("./View/Users/UserView"))
const UserLogin = lazy(() => import("./View/Users/UserLogin"))
const UserForgotPassword = lazy(() => import("./View/Users/UserForgotPassword"))
// import UserLogin from "./View/Users/UserLogin";
// import UserForgotPassword from "./View/Users/UserForgotPassword";

const MeetingtypeIndex = lazy(() => import("./View/Meetingtype/MeetingtypeIndex"))
const MeetingtypeView = lazy(() => import("./View/Meetingtype/MeetingtypeView"))

const FindingtypeIndex = lazy(() => import("./View/Findingtype/FindingtypeIndex"))
const FindingtypeView = lazy(() => import("./View/Findingtype/FindingtypeView"))

const MaintenancetypeIndex = lazy(() => import("./View/Maintenancetype/MaintenancetypeIndex"))
const MaintenancetypeEdit = lazy(() => import("./View/Maintenancetype/MaintenancetypeEdit"))

const MeetingIndex = lazy(() => import("./View/Meeting/MeetingIndex"))
const MeetingView = lazy(() => import("./View/Meeting/MeetingView"))

const DeviceIndex = lazy(() => import("./View/Device/DeviceIndex"))
const DeviceView = lazy(() => import("./View/Device/DeviceView"))

const ActivityIndex = lazy(() => import("./View/Activity/ActivityIndex"))
const ActivityView = lazy(() => import("./View/Activity/ActivityView"))

const AppointmentIndex = lazy(() => import("./View/Appointment/AppointmentIndex"))
const AppointmentView = lazy(() => import("./View/Appointment/AppointmentView"))
const AppointmentAdd = lazy(() => import("./View/Appointment/AppointmentAdd"))

const ManagementreviewIndex = lazy(() => import("./View/Managementreview/ManagementreviewIndex"))
const ManagementreviewView = lazy(() => import("./View/Managementreview/ManagementreviewView"))
const QualitydashboardView = lazy(() => import("./View/Managementreview/QualitydashboardView"))
const ActionnameIndex = lazy(() => import("./View/Actionname/ActionnameIndex"))
const ActionnameView = lazy(() => import("./View/Actionname/ActionnameView"))
const BarcodeScan = lazy(() => import("./View/Barcode/BarcodeScan"))
const DayNew = lazy(() => import("./View/Day/DayNew"))
const UserChangePassword = lazy(() => import("./View/Users/UserChangePassword"))
const OrderIndex = lazy(() => import("./View/Orders/OrderIndex"))
const OrderView = lazy(() => import("./View/Orders/OrderView"))
const DeviceMaintenance = lazy(() => import("./View/Device/DeviceMaintenance"))
const MaintenancedoneView = lazy(() => import("./View/Maintenancedone/MaintenancedoneView"))
const DayRemarks = lazy(() => import("./View/Day/DayRemarks"))
const NotificationView = lazy(() => import("./View/Notification/NotificationView"))
const AuditPdf = lazy(() => import("./View/Audit/AuditPdf"))
const QuarpaView = lazy(() => import("./View/Quarpa/QuarpaView"))
const QuarpaIndex = lazy(() => import("./View/Quarpa/QuarpaIndex"))
const QuarpaPublicIndex = lazy(() => import("./View/Quarpa/QuarpaPublicIndex"))
const ProfileIndex = lazy(() => import("./View/Profiles/ProfileIndex"))
const ProfileView = lazy(() => import("./View/Profiles/ProfileView"))
const PageHome = lazy(() => import("./View/Pages/PageHome"))
const RiskView = lazy(() => import("./View/Risk/RiskView"))
const RiskgroupView = lazy(() => import("./View/Riskgroup/RiskgroupView"))
const RiskgroupIndex = lazy(() => import("./View/Riskgroup/RiskgroupIndex"))


const MainBox = props => {
    const userContext = useContext(AuthContext);

    if (userContext.loading) {
        return <p>Context loading</p>
    }


    return (
        <Box sx={{flexGrow: 1}}>
            <Suspense fallback={<div>Loading...</div>}>
                <Routes>


                    <Route path="/" element={<PageHome/>}/>
                    <Route path="/login" element={<UserLogin/>}/>


                    <Route path="/users/forgotpassword" element={<UserForgotPassword/>}/>


                    <Route path="/slidesendings/index"
                           element={<RequireAuth><SlidesendingIndex/></RequireAuth>}/>
                    <Route path="/slidesendings/view/:id"
                           element={<RequireAuth><SlidesendingView/></RequireAuth>}/>


                    <Route path="/messages/index"
                           element={<RequireAuth><MessageIndex/></RequireAuth>}/>

                    <Route path="/menuitems/index"
                           element={<RequireAuth><MenuitemIndex/></RequireAuth>}/>

                    <Route path="/findings/index"
                           element={<RequireAuth><FindingOverview/></RequireAuth>}/>
                    <Route path="/findings/index/:id"
                           element={<RequireAuth><FindingIndex/></RequireAuth>}/>
                    <Route path="/findings/view/:id"
                           element={<RequireAuth><FindingView/></RequireAuth>}/>

                    <Route path="/stocks/index"
                           element={<RequireAuth><StockIndex/></RequireAuth>}/>
                    <Route path="/stocks/mirror"
                           element={<RequireAuth><StockMirror/></RequireAuth>}/>
                    <Route path="/stocks/start"
                           element={<RequireAuth><StockStart/></RequireAuth>}/>
                    <Route path="/stocks/end"
                           element={<RequireAuth><StockEnd/></RequireAuth>}/>
                    <Route path="/stocks/view/:id/:stockitemId"
                           element={<RequireAuth><StockView/></RequireAuth>}/>
                    <Route path="/stocks/view/:id"
                           element={<RequireAuth><StockView/></RequireAuth>}/>

                    <Route path="/orders/index"
                           element={<RequireAuth><OrderIndex/></RequireAuth>}/>
                    <Route path="/orders/view/:id"
                           element={<RequireAuth><OrderView/></RequireAuth>}/>

                    <Route path="/riskgroups/index"
                           element={<RequireAuth><RiskgroupIndex/></RequireAuth>}/>
                    <Route path="/riskgroups/view/:id"
                           element={<RequireAuth><RiskgroupView/></RequireAuth>}/>

                    <Route path="/risks/view/:id"
                           element={<RequireAuth><RiskView/></RequireAuth>}/>


                    <Route path="/audits/index"
                           element={<RequireAuth><AuditIndex/></RequireAuth>}/>
                    <Route path="/audits/mirror"
                           element={<RequireAuth><AuditMirror/></RequireAuth>}/>
                    <Route path="/audits/view/:id"
                           element={<RequireAuth><AuditView/></RequireAuth>}/>
                    <Route path="/audits/pdf/:id"
                           element={<RequireAuth><AuditPdf/></RequireAuth>}/>


                    <Route path="/manufacturers/index"
                           element={<RequireAuth><ManufacturerIndex/></RequireAuth>}/>
                    <Route path="/manufacturers/mirror"
                           element={<RequireAuth><ManufacturerMirror/></RequireAuth>}/>
                    <Route path="/manufacturers/view/:id"
                           element={<RequireAuth><ManufacturerView/></RequireAuth>}/>


                    <Route path="/profiles/index"
                           element={<RequireAuth><ProfileIndex/></RequireAuth>}/>
                    <Route path="/profiles/view/:id"
                           element={<RequireAuth><ProfileView/></RequireAuth>}/>

                    <Route path="/absents/index"
                           element={<RequireAuth><AbsentView/></RequireAuth>}/>
                    <Route path="/absents/add"
                           element={<RequireAuth><AbsentAdd/></RequireAuth>}/>


                    <Route path="/users/index"
                           element={<RequireAuth><UserIndex/></RequireAuth>}/>
                    <Route path="/users/view/:id"
                           element={<RequireAuth><UserView/></RequireAuth>}/>
                    <Route path="/users/add" element={<RequireAuth><UserAdd/></RequireAuth>}/>
                    <Route path="/users/self" element={<RequireAuth><UserMe/></RequireAuth>}/>
                    <Route path="/users/changepassword"
                           element={<RequireAuth><UserChangePassword/></RequireAuth>}/>

                    <Route path="/meetingtypes/index"
                           element={<RequireAuth><MeetingtypeIndex/></RequireAuth>}/>
                    <Route path="/meetingtypes/view/:id"
                           element={<RequireAuth><MeetingtypeView/></RequireAuth>}/>

                    <Route path="/findingtypes/index"
                           element={<RequireAuth><FindingtypeIndex/></RequireAuth>}/>
                    <Route path="/findingtypes/view/:id"
                           element={<RequireAuth><FindingtypeView/></RequireAuth>}/>


                    <Route path="/maintenancetypes/index"
                           element={<RequireAuth><MaintenancetypeIndex/></RequireAuth>}/>
                    <Route path="/maintenancetypes/view/:id"
                           element={<RequireAuth><MaintenancetypeEdit/></RequireAuth>}/>

                    <Route path="/meetings/index"
                           element={<RequireAuth><MeetingIndex/></RequireAuth>}/>
                    <Route path="/meetings/view/:id"
                           element={<RequireAuth><MeetingView/></RequireAuth>}/>

                    <Route path="/days/view/:year/:month/:day"
                           element={<RequireAuth><DayNew/></RequireAuth>}/>
                    <Route path="/days/view/:date"
                           element={<RequireAuth><DayNew/></RequireAuth>}/>
                    <Route path="/days/view" element={<RequireAuth><DayNew/></RequireAuth>}/>
                    <Route path="/days/remarks"
                           element={<RequireAuth><DayRemarks/></RequireAuth>}/>

                    <Route path="/devices/index"
                           element={<RequireAuth><DeviceIndex/></RequireAuth>}/>
                    <Route path="/devices/maintenance"
                           element={<RequireAuth><DeviceMaintenance/></RequireAuth>}/>
                    <Route path="/devices/view/:id"
                           element={<RequireAuth><DeviceView/></RequireAuth>}/>

                    <Route path="/maintenancedones/view/:id"
                           element={<RequireAuth><MaintenancedoneView/></RequireAuth>}/>

                    <Route path="/activities/index"
                           element={<RequireAuth><ActivityIndex/></RequireAuth>}/>
                    <Route path="/activities/view/:id"
                           element={<RequireAuth><ActivityView/></RequireAuth>}/>
                    <Route path="/appointments/index"
                           element={<RequireAuth><AppointmentIndex/></RequireAuth>}/>
                    <Route path="/appointments/view/:id"
                           element={<RequireAuth><AppointmentView/></RequireAuth>}/>

                    <Route
                        path="/appointments/add"
                        element={<RequireAuth><AppointmentAdd/></RequireAuth>}
                    />
                    <Route
                        path="/managementreviews/index"
                        element={<RequireAuth><ManagementreviewIndex/></RequireAuth>}
                    />
                    <Route
                        path="/managementreviews/view/:id"
                        element={<RequireAuth><ManagementreviewView/></RequireAuth>}
                    />
                    <Route
                        path="/qualitydashboards/view/:id"
                        element={<RequireAuth><QualitydashboardView/></RequireAuth>}
                    />
                    <Route
                        path="/actionnames/index"
                        element={<RequireAuth><ActionnameIndex/></RequireAuth>}
                    />
                    <Route
                        path="/actionnames/view/:id"
                        element={<RequireAuth><ActionnameView/></RequireAuth>}
                    />
                    <Route
                        path="/barcode/scan"
                        element={<RequireAuth><BarcodeScan/></RequireAuth>}
                    />
                    <Route
                        path="/quarpas/adminindex"
                        element={<RequireAuth><QuarpaIndex/></RequireAuth>}
                    />
                    <Route
                        path="/quarpas/adminview/:id"
                        element={<RequireAuth><QuarpaView/></RequireAuth>}
                    />
                    <Route
                        path="/quarpas/index"
                        element={<RequireAuth><QuarpaPublicIndex/></RequireAuth>}
                    />
                    <Route
                        path="/notifications/index"
                        element={<RequireAuth><NotificationView/></RequireAuth>}
                    />

                    <Route component={PageUnknown}/>
                </Routes>
            </Suspense>
        </Box>
    )
}

export default MainBox

const RequireAuth = ({children, redirectTo}) => {
    const userContext = useContext(AuthContext);
    return userContext.userLoggedIn() ? children : <Navigate to={redirectTo}/>
}
RequireAuth.defaultProps = {
    redirectTo: "/login"
}